import { render } from "./PerformanceCategory.vue?vue&type=template&id=2647eebe&scoped=true&lang=pug"
import script from "./PerformanceCategory.vue?vue&type=script&lang=js"
export * from "./PerformanceCategory.vue?vue&type=script&lang=js"

import "./PerformanceCategory.vue?vue&type=style&index=0&id=2647eebe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2647eebe"]])

export default __exports__